// extracted by mini-css-extract-plugin
export default {"main":"SocialPage_main__Lw0fB","links":"SocialPage_links__4IdaQ","link":"SocialPage_link__ptPmw"};